import { render, staticRenderFns } from "./headCom.vue?vue&type=template&id=24298ede&scoped=true&"
import script from "./headCom.vue?vue&type=script&lang=js&"
export * from "./headCom.vue?vue&type=script&lang=js&"
import style0 from "./headCom.vue?vue&type=style&index=0&id=24298ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24298ede",
  null
  
)

export default component.exports